export default __webpack_public_path__ + "static/media/dwn-arr-white.afb33e09.svg";